import React, { useState,useContext } from "react";
import api from "../../axios/api";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ClipLoader } from "react-spinners";
import { GlobalContext } from "../../contexts/GlobalContext";

const schema = yup.object().shape({
  treeId: yup.string().required("Tree ID is required"),
  image: yup.mixed().required("Tree Image is required"),
  height: yup.number()
    .typeError("Height must be a number")
    .required("Height is required")
    .positive("Height must be positive"),
  diameter: yup.number()
    .typeError("Diameter must be a number")
    .required("Diameter is required")
    .positive("Diameter must be positive"),
});

const TreeHistory = () => {
  const [treeDetails, setTreeDetails] = useState(null);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
    const {
      setLoggedIn,
      isLoggedIn,
    } = useContext(GlobalContext);

  const { register, handleSubmit, formState: { errors }, setValue, watch, trigger, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const handleSearch = async () => {
     if (!requireLogin()) return;
    const isValid = await trigger("treeId");

    if (!isValid) return; // Stop if validation fails
    setIsSearching(true);
    try {
      const response = await api.get(`/api/upload/treehistory/${watch("treeId").trim()}`);
      const data = response.data;
      if (data.success) {
        setTreeDetails(data.tree);
        setError("");
      } else {
        setError("Tree not found");
        setTreeDetails(null);
      }
    } catch (error) {
      console.log(error);
      setError("Tree Does not exist");
    } finally {
      setIsSearching(false);
    }
  };

  const requireLogin = () => {
  if (!isLoggedIn) {
    toast.error("Please login to fill this form");
    return false;
  }

  return true;
};

  const handleImageUpload = (e) => {
    if (!requireLogin()) {
    e.target.value = "";
    return;
  }

    const file = e.target.files[0];
    // Check if the file is an image
    if (!file || !file.type.startsWith("image/")) {
      setError("Please upload a valid image file.");
      toast.error("Please upload a valid image file.");
      e.target.value = "";
      return;
    }

    setValue("image", file);
  };

  const handleSubmitForm = async (data) => {
     if (!requireLogin()) return;
    if (!treeDetails) {
      setError("Please search for a valid tree first");
      return;
    }

    const formData = new FormData();
    formData.append("id",treeDetails.id);
    formData.append("image", data.image);
    formData.append("tree_id", treeDetails.tree_id);
    formData.append("userId", treeDetails.userId);
    formData.append("imageName", data.image.name);
    formData.append("lat", treeDetails.lat);
    formData.append("lng", treeDetails.lng);
    formData.append("height", data.height);
    formData.append("diameter", data.diameter);

    try {
      setIsSubmitting(true);
      const response = await api.post(
        `/api/upload/update-tree-history?lat=${treeDetails.lat}&lng=${treeDetails.lng}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        toast.success("Tree verified and uploaded successfully!");
        setTreeDetails(null);
        reset();
      }
      if (!response.data.success) {
        toast.error("Error verifying tree");
      }
    } catch (error) {
      setError("An error occurred while submitting the form");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setTreeDetails(null);
    setError("");
    reset();
    toast.info("Upload canceled");
  };

  return (
    <div>
      <h3>Update Tree Growth</h3>
      <p style={{ fontSize: '13px' }}>NOTE: fields marked with <span style={{ color: 'red' }}>*</span> are mandatory to input.</p>
      <br/>
      <p style={{ fontSize: '13px' }}>Use approximated values for measurements such as tree height and diameter if exact values are not available.</p>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
  type="text"
  placeholder="Enter Tree ID *"
  {...register("treeId", {
    onChange: (e) => {
      if (!requireLogin()) {
        e.target.value = "";
        setValue("treeId", "");
      }
    },
  })}
  style={{
    flex: "1",
    borderColor: errors.treeId ? "red" : "",
  }}
/>
          <button
            type="button"
            onClick={handleSearch}
            style={{ margin: "5px", marginBottom: "25px" }}
          >
            {isSearching ? (
              <ClipLoader size={20} color="#ffffff" />
            ) : (
              'Search'
            )}
          </button>
        </div>
        {errors.treeId && (
          <p className="error-message" style={{ color: "red" }}>
            {errors.treeId.message}
          </p>
        )}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {treeDetails && (
          <div>
            <p>Tree Name :  <p style={{fontWeight:"normal"}}>{treeDetails.treeName}</p></p>
            <p> TreeId : <p style={{fontWeight:"normal"}}>{treeDetails.tree_id}</p></p>
            <input
              type="file"
              onChange={handleImageUpload}
              style={{ borderColor: errors.image ? "red" : "" }}
            />
            {errors.image && (
              <p className="error-message" style={{ color: "red" }}>
                {errors.image.message}
              </p>
            )}

            <div>
              <input
  type="number"
  step="0.01"
  placeholder="Diameter At Breast Height (Meter Only)*"
  {...register("diameter", {
    onChange: (e) => {
      if (!requireLogin()) {
        e.target.value = "";
        setValue("diameter", "");
      }
    },
  })}
  style={{ borderColor: errors.diameter ? "red" : "" }}
/>
              {errors.diameter && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.diameter.message}
                </p>
              )}
              
              <input
  type="number"
  step="0.01"
  placeholder="Height (Meter Only)*"
  {...register("height", {
    onChange: (e) => {
      if (!requireLogin()) {
        e.target.value = "";
        setValue("height", "");
      }
    },
  })}
  style={{ borderColor: errors.height ? "red" : "" }}
/>
              {errors.height && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.height.message}
                </p>
              )}
            </div>

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <ClipLoader size={20} color="#ffffff" />
                </>
              ) : (
                'Submit'
              )}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              disabled={isSubmitting}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:bg-red-300"
            >
              Cancel
            </button>
          </div>
        )}
      </form>
      <ToastContainer />
    </div>
  );
};

export default TreeHistory;